const messages = {
  es: {
    translations: {
      app: { title: "Numera Builder" },
      errors: { generic: "Algo salió mal. Inténtalo de nuevo." },
      login: {
        title: "Iniciar sesión",
        email: "Correo",
        password: "Contraseña",
        submit: "Entrar",
        invalid: "Credenciales inválidas",
      },
      menu: {
        groups: {
          telefonia: "Telefonía",
          builder: "Constructor",
          integrations: "Integraciones",
        },
        dashboard: "Panel",
        assistant: "Asistente",
        numbers: "Números",
        cdrs: "Llamadas",
        applications: "Aplicaciones",
        templates: "Templates",
        events: "Eventos",
        connectors: "Conectores",
        datasets: "Tablas",
        data: "Datos",
        storage: "Almacenamiento",
        secrets: "Secrets",
        webhooks: "Webhooks",
        usage: "Uso & Saldo",
        developers: "Desarrolladores",
        agents: "Agentes de IA",
        schedules: "Agendamentos",
        users: "Usuarios",
        logout: "Salir",
      },
      events: {
        title: "Eventos",
        clear: "Limpiar",
        confirmClear: "¿Borrar todos los eventos?",
        empty: "Aún no hay eventos.",
        loadMore: "Cargar más",
        selectHint: "Selecciona un evento para ver los detalles.",
        today: "Hoy",
        yesterday: "Ayer",
        app: "Aplicación",
        type: "Tipo",
      },
      apps: {
        title: "Aplicaciones",
        new: "Nueva aplicación",
        search: "Buscar aplicaciones",
        empty: "Ninguna aplicación. Haz clic en \"Nueva aplicación\" para empezar.",
        name: "Nombre",
        trigger: "Disparador",
        updatedAt: "Actualizado",
        lastRunAt: "Última ejecución",
        confirmDelete: "¿Eliminar esta aplicación?",
        saved: "Aplicación guardada.",
        namePlaceholder: "Nombre de la aplicación",
        previewJson: "Previsualizar JSON",
        copy: "Copiar",
        copied: "JSON copiado.",
        copiedShort: "Copiado",
        close: "Cerrar",
        status: "Estado",
        publish: "Publicar",
        published: "Publicada v{{v}} y desplegada.",
        publishedShort: "Publicada",
        unpublished: "No publicada",
        unpublishedShort: "cambios no publicados",
        draftStatus: "Borrador",
        history: "Historial",
        version: "Versión",
        deploy: "Despliegue",
        when: "Cuándo",
        notes: "Notas",
        live: "En vivo",
        archived: "Archivada",
        restore: "Restaurar",
        restored: "Versión v{{v}} restaurada en el borrador.",
        noVersions: "Aún no hay versiones publicadas.",
        saveFirst: "Guarda la aplicación primero.",
        addStep: "Añadir paso",
      },
      vars: {
        title: "Seleccionar variable",
        search: "Buscar variables en el ámbito...",
        select: "Seleccionar",
        insert: "Insertar variable",
        empty: "Genera un evento de prueba en el disparador para ver las variables.",
        noMatch: "No se encontraron variables.",
      },
      triggers: {
        title: "Disparador",
        choose: "Elegir disparador",
        add: "Añadir disparador",
        change: "Cambiar disparador",
        empty: "Sin disparador. Elige cómo se dispara esta aplicación.",
        webhookUrl: "URL del webhook",
        webhookSaveHint: "Guarda la aplicación para generar la URL.",
        testEvent: "Evento de prueba",
        exampleBody: "Cuerpo de ejemplo (JSON)",
        generateTest: "Generar evento de prueba",
        invalidJson: "JSON inválido en el cuerpo de ejemplo.",
        tested: "Evento de prueba generado.",
        exports: "Exports (referenciables en los nodos de abajo)",
        tabConfig: "Configuración",
        tabEvents: "Eventos",
        tabResults: "Resultados",
        noEvents: "Aún no hay eventos. Usa \"Evento de prueba\" o llama la URL del webhook.",
        selectEventHint: "Selecciona un evento en la sección Eventos para ver sus datos.",
        schemaHint: "Ejemplo de los campos que recibe este disparador — usa estas rutas como variables (aún no hubo evento real).",
        refresh: "Actualizar",
        method: "Método",
        sendTest: "Enviar solicitud",
        testSent: "Solicitud enviada.",
        testHint: "Dispara una solicitud real al webhook de esta aplicación; el evento aparece en la pestaña Eventos.",
        inbound_call: {
          title: "Al recibir llamada",
          desc: "Se dispara cuando llega una llamada a un número vinculado a esta aplicación.",
        },
        webhook: {
          title: "Webhook",
          desc: "Se dispara cuando un sistema externo llama una URL (HTTP). Útil para originar llamadas.",
        },
        scheduled: {
          title: "Programado",
          desc: "Se dispara en horarios definidos (expresión cron).",
        },
      },
      numbers: {
        title: "Números",
        search: "Buscar por número o ciudad",
        empty: "No se encontraron números.",
        number: "Número",
        type: "Tipo",
        city: "Ciudad",
        inbound: "Aplicación (entrada)",
        outbound: "Aplicación (salida)",
        types: { fixo: "Fijo", movel: "Móvil" },
        link: "Vincular aplicaciones",
        none: "Ninguna",
        linkHint: "Entrada: el flujo o agente que atiende cuando alguien llama a este número. Para llamar desde él, elige el número en el nodo Iniciar llamada.",
      },
      projects: {
        title: "Proyectos",
        new: "Nuevo proyecto",
        search: "Buscar proyectos",
        empty: "No se encontraron proyectos.",
        name: "Nombre",
        status: "Estado",
        owner: "Responsable",
        updatedAt: "Actualizado",
        confirmDelete: "¿Eliminar este proyecto?",
        deleted: "Proyecto eliminado.",
        saved: "Proyecto guardado.",
      },
      status: {
        draft: "Borrador",
        active: "Activo",
        paused: "Pausado",
        archived: "Archivado",
      },
      config: {
        back: "Volver",
        save: "Guardar",
        tabs: { general: "General", advanced: "Avanzado" },
        fields: {
          name: "Nombre",
          description: "Descripción",
          status: "Estado",
        },
        validation: { nameRequired: "Indica un nombre" },
      },
    },
  },
};

export { messages };
